import { Injectable } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

import { Store } from '@ngrx/store';

import { I18nService } from '@recruitee/i18n';
import { UnassignLocationFacade } from '@recruitee/locations';
import { DialogService } from '@recruitee/user-interface';

import { RequisitionFormManagerService } from '../../services/requisition-form-manager.service';

@Injectable()
export class UnassignLocationRequisitionFacade extends UnassignLocationFacade {
  public validateLocations: undefined;

  constructor(
    public store: Store,
    public dialogService: DialogService,
    public i18n: I18nService,
    private requisitionFormManager: RequisitionFormManagerService,
  ) {
    super(dialogService, i18n, store);
  }
  public get locationsControl() {
    return <FormArray<FormControl>>this.requisitionFormManager.form.controls.locationIds!;
  }
}
